// src/pages/ProfilePage.js
import React, { useEffect, useState } from 'react';
import './ProfilePage.css'; // Optional CSS

// Define the base API URL using an environment variable.
const API_URL = process.env.REACT_APP_API_URL;

const ProfilePage = ({ isAuthenticated }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    fetch(`${API_URL}/dashboard`, {
      headers: { token }
    })
      .then(response => response.json())
      .then(data => setUser(data))
      .catch(err => console.error(err));
  }, []);

  if (!isAuthenticated) {
    return <div>Please log in to view your profile.</div>;
  }

  if (!user) return <div>Loading...</div>;

  return (
    <div className="profile-page">
      <h2>Your Profile</h2>
      <p><strong>Name:</strong> {user.user_name}</p>
      <p><strong>Email:</strong> {user.user_email}</p>
    </div>
  );
};

export default ProfilePage;
